import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { useOutsideClick } from "hooks";
import { Button } from "components";
import { IoTriangleSharp } from 'react-icons/io5'

export const MenuDropDown = ({
    title = '',
    onParentCopy = () => { },
    onReset = () => { },
    disabled = false,
    data
}) => {

    const menuRef = useRef(null);

    useOutsideClick(menuRef, () => {
        setMenuSelected(false);
    })

    const [menuSelected, setMenuSelected] = useState(false);

    useEffect(() => {
        console.log(menuSelected);
    }, [menuSelected])

    useEffect(() => {
        if (disabled) {
            setMenuSelected(!disabled);
        }
    }, [disabled])

    return (
        <div className="ml-auto" ref={menuRef}>
            <Menu className="ml-2 my-auto">
                <MenuButton
                    buttonTheme={"dark"}
                    width="150px"
                    size="small"
                    onClick={() => setMenuSelected(!menuSelected)}
                    isLoading={disabled}
                >
                    <MenuText>{title}</MenuText>
                    <MenuIcon menuSelected={menuSelected}>
                        <IoTriangleSharp />
                    </MenuIcon>
                </MenuButton>
                {menuSelected &&
                    <DropDown >
                        <MenuItem
                            buttonTheme={"dark"}
                            width="150px"
                            size="small"
                            onClick={() => onParentCopy(data)}
                            disabled={disabled}
                        > COPY DATA
                        </MenuItem>
                       <MenuItem
                            buttonTheme={"dark"}
                            width="150px"
                            size="small"
                            onClick={() => onReset(data)}
                            disabled={disabled}
                        > RESET
                        </MenuItem>
                    </DropDown>
                }
            </Menu>
        </div>
    )
}

const Menu = styled.div`
  position:relative;
  padding: 0;
  outline:0;
  text-align:left;
  width: 100%;
  height: 32px;
  box-sizing: border-box;
  
  button {
    height:30px !important;
  }
`

const MenuButton = styled(Button)`
  display: flex;
  align-items: center;
  padding: 0px;
  border: none;
  opacity: none;
`

const MenuText = styled.div`
  border: 1px solid #2B2B2B;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
`

const MenuIcon = styled.div`
  width: 25%;
  border: 1px solid #2B2B2B;
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;

  svg{
    font-size: 14px;
    transition: all 300ms ease;
    ${({ menuSelected }) => menuSelected && 'transform: rotate(180deg);'}
  }
`

const MenuItem = styled(Button)`
    margin-top: 2px;
`

const DropDown = styled.div`
    margin: 3px 0 0 0;
    pointer-events: auto;
    position: absolute;
    z-index: 1;
    top: 29px;
    color: white;
    background: #191919;
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.15);
    border-radius: 0px;
    max-height: 320px;

`
